
export default function (Component) {
  Component.options.__source = "src/views/system/controllers/notices/notices-show/index.vue"
}
